// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"468":"9794fd92","4322":"887f643b"}[chunkId] + ".css";
};